import React from "react";
import MainContentCard from "../../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../../components/shared/ErrorBoundaryRoutes";
import ListTCLocalPurchasesChild from "./ListTCLocalPurchasesChild";

const ListTCLocalPurchases = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="ListTCLocalPurchases" route="/list-lpo">
        <ListTCLocalPurchasesChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default ListTCLocalPurchases;
